export default __webpack_public_path__ + "static/media/Radio.79c0ecb2.svg";